import React from 'react';
import PropTypes from 'prop-types';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Checkbox,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';

const ColumnSelectDropdown = ({
  label,
  columns, // Receive the full columns configuration
  visibleColumns,
  onToggle,
  onSelect,
  selectMode = 'visibility',
  bg,
  color,
  size,
}) => {
  const buttonBg = useColorModeValue(bg || 'white', 'black');
  const buttonColor = useColorModeValue(color || 'black', 'white');
  const checkboxColor = useColorModeValue('blue', 'green');

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        bg={buttonBg}
        color={buttonColor}
        size={size}
      >
        {label}
      </MenuButton>
      <MenuList maxHeight="300px" overflowY="auto" bg={buttonBg}>
        {columns.map((column) => (
          <MenuItem key={column.id} bg={buttonBg} color={buttonColor}>
            {selectMode === 'visibility' ? (
              <Checkbox
                colorScheme={checkboxColor}
                isChecked={visibleColumns[column.id]} // Use column.id to track visibility
                onChange={() => onToggle(column.id)} // Toggle using column.id
              >
                {column.title} {/* Display the column title */}
              </Checkbox>
            ) : (
              <Button
                variant="link"
                onClick={() => onSelect(column.title)} // Use column.id for selecting/filtering
              >
                {column.title}
              </Button>
            )}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

ColumnSelectDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired, // Use the full column object from config
  visibleColumns: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  selectMode: PropTypes.oneOf(['filter', 'visibility']),
  bg: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};

ColumnSelectDropdown.defaultProps = {
  selectMode: 'visibility',
  size: 'md',
};

export default ColumnSelectDropdown;
